import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20golden%20and%20cream%20toned%20background%20with%20soft%20flowing%20gradient%20shapes%2C%20minimalist%20elegant%20corporate%20style%2C%20subtle%20texture%2C%20luxurious%20warm%20atmosphere%2C%20no%20text%2C%20clean%20modern%20design%2C%20soft%20ambient%20light&width=1800&height=900&seq=hero-bg-91c&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/30" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
          探索 <span className="text-primary-400">91c</span> 的全部价值
        </h1>
        <p className="mt-5 text-base md:text-lg text-background-100/80 max-w-2xl mx-auto leading-relaxed">
          您值得信赖的首选平台，汇聚核心功能、使用指南与用户评价。
          无论您是初次了解还是深度用户，这里为您提供最全面的信息与服务入口。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/features"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索功能
          </Link>
          <Link
            to="/category/tutorials"
            className="px-8 py-3 border border-background-50/40 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            查看教程
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-xl mx-auto">
          {[
            { value: '50,000+', label: '活跃用户' },
            { value: '4.8/5', label: '用户评分' },
            { value: '200+', label: '企业客户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</p>
              <p className="text-xs md:text-sm text-background-100/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}